var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.syncs },
      on: {
        "update:visible": function ($event) {
          _vm.syncs = $event
        },
      },
    },
    [_c("div", { attrs: { slot: "footer" }, slot: "footer" }, [_vm._v("1111")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }